import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const LicensesAPI = {
  getMyLicense: async (teamId: string, userId: string): Promise<any> =>
    (await initAxios())
      ?.get(`/licenses/${userId}/my-license/${teamId}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  changeRole: async (teamId: string, params: any): Promise<any> =>
    (await initAxios())
      ?.post(`/licenses/${teamId}/change-role`, JSON.stringify(params))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  assignLicenses: async (teamId: string, params: any): Promise<any> =>
    (await initAxios())
      ?.post(`/licenses/${teamId}/assign`, JSON.stringify(params))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getLicensesForTeam: async (teamId: string): Promise<any> =>
    (await initAxios())
      ?.get(`/licenses/${teamId}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getMyLicenseBatch: async (userId: string, groupIds: string[]): Promise<any> => {
    if (groupIds.length === 0) return { success: true, result: {} };
    return (await initAxios())
      ?.get(`/licenses/${userId}/my-licenses/batch?groupIds=${groupIds.join(',')}`)
      .then((resp) => ({ success: true, result: resp.data?.data ?? {} }))
      .catch((err) => ({ success: false, result: parseErrorMsg(err) }));
  },
};

export default LicensesAPI;
